import { render, staticRenderFns } from "./DesafioSubmissionsView.vue?vue&type=template&id=691b182f&scoped=true&"
import script from "./DesafioSubmissionsView.vue?vue&type=script&lang=js&"
export * from "./DesafioSubmissionsView.vue?vue&type=script&lang=js&"
import style0 from "./DesafioSubmissionsView.vue?vue&type=style&index=0&id=691b182f&lang=scss&scoped=true&"
import style1 from "./DesafioSubmissionsView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691b182f",
  null
  
)

export default component.exports